module.exports = __webpack_public_path__ + "static/media/Auto_Save.25cd382c.svg";